import { render } from "./OnboardingTopNav.vue?vue&type=template&id=1b434d5a&scoped=true"
import script from "./OnboardingTopNav.vue?vue&type=script&lang=js"
export * from "./OnboardingTopNav.vue?vue&type=script&lang=js"

import "./OnboardingTopNav.vue?vue&type=style&index=0&id=1b434d5a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b434d5a"],['__file',"src/scripts/portfolioManager/onboarding/OnboardingTopNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b434d5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b434d5a', __exports__)) {
    api.reload('1b434d5a', __exports__)
  }
  
  module.hot.accept("./OnboardingTopNav.vue?vue&type=template&id=1b434d5a&scoped=true", () => {
    api.rerender('1b434d5a', render)
  })

}


export default __exports__